export class Running {
  constructor(form) {
    if (form) {
      this.id = form.id;
      this.type = form.type;
      this.name = form.name;
      this.prizeVOList = form.prizeVOList;
      this.luckyDrawType = form.luckyDrawType;
      this.ridingDistance = form.ridingDistance;
      this.sweepstakesPageTitle = form.sweepstakesPageTitle;
      this.prizePreviewChart = form.prizePreviewChart;
      // 对线上数据进行兼容
      if (Array.isArray(form.multiDistance)) {
        this.multiDistance = form.multiDistance.map((item, index) => {
          return {
            value: item,
            id: index,
          };
        });
      } else {
        this.multiDistance = [{
          value: form.runningDistance,
          id: 0,
        }];
      }
      this.exportTime = [form.beginTime, form.endTime];
      this.content = form.content;
      // this.sweepstakesRules = form.sweepstakesRules;
      this.announcement = form.announcement;
      this.recommendedCourseId = form.recommendedCourseId;
      // 15
      // this.prizeInformationAddDTOList = form.prizeInformationAddDTOList ? form.prizeInformationAddDTOList : [{
      //   prizeLevel: 1,
      //   prizeName: "",
      //   prizeNum: null,
      // }];
      this.isShow = form.isShow;
      this.coverImage = form.coverImage;
      this.communityBanner = form.communityBanner;
      this.courseBanner = form.courseBanner;
      this.courseList = form.courseList || [];
    } else {
      this.clear();
    }
  }

  get exportTime() {
    if (this.beginTime && this.endTime) {
      return [this.beginTime, this.endTime];
    } else {
      return [];
    }
  }

  set exportTime(exportTime) {
    if (exportTime && Array.isArray(exportTime) && exportTime.length === 2) {
      this.beginTime = exportTime[0];
      this.endTime = exportTime[1];
    } else {
      this.beginTime = null;
      this.endTime = null;
    }
  }

  // formatForm() {
  //   if (this.prizeInformationAddDTOList) {
  //     // 格式化掉没有名称的奖品
  //     this.prizeInformationAddDTOList = this.prizeInformationAddDTOList.filter((item, index) => {
  //       return item.prizeName && item.prizeNum && item.prizeNum != '0';
  //     });
  //     // 再格式化变量中的类型
  //     if (this.prizeInformationAddDTOList.length) {
  //       this.prizeInformationAddDTOList = this.prizeInformationAddDTOList?.map((item) => {
  //         return {
  //           ...item,
  //           prizeNum: Number(item.prizeNum),
  //         };
  //       });
  //     }
  //   }
  // }

  clear() {
    this.id = ''; // id
    this.type = 0;
    this.name = ''; // 活动标题
    // this.runningDistance = null; // 跑步公里
    this.multiDistance = [{ id: '' }]; // 多目标公里
    this.exportTime = []; // 活动时间
    this.content = ''; // 活动正文
    // this.sweepstakesRules = ''; // 抽奖规则
    this.announcement = ''; // 注意事项
    this.recommendedCourseId = []; // 推荐课程id
    this.courseList = []; // 推荐课程id
    this.prizeVOList = [];
    this.sweepstakesPageTitle = '';
    this.prizePreviewChart = '';
    this.ridingDistance = [
      {
        runningDistance: '',
        prizeInformation: {
          poolId: '',
          goal: '',
        },
      },
    ];
    this.luckyDrawType = 0;
    // this.prizeInformationAddDTOList = [{
    //   prizeLevel: 1,
    //   prizeName: "",
    //   prizeNum: null,
    // }]; // 奖品配置
    this.isShow = 0; // 列表是否展示
    this.coverImage = {
      activityDetailsPageHeader: '', // 活动详情页头图
      activityListPagePicture: '', // 活动列表页图片
      bannerDiagramOfBottomCommunity: '', // 底部社群banner图
      myActivityListPictures: '', // 我的活动列表图
      shareCardImage: '', // 分享卡片长途
      shareImage: '', // 分享长图
      runningBackgroundImage: '', // 跑步背景图
      // 测试数据
      // activityDetailsPageHeader: 'https://uauat-1257321318.file.myqcloud.com/static/image/dev/running/82c5fe6d75d37cd3a031b4bf5252db5c.jpg?imageMogr2/format/webp/quality/50', // 活动详情页头图
      // activityListPagePicture: 'https://uauat-1257321318.file.myqcloud.com/static/image/dev/running/6b932c541cc4750c9e0c24564732d1a3.png?imageMogr2/format/webp/quality/50', // 活动列表页图片
      // bannerDiagramOfBottomCommunity: 'https://uauat-1257321318.file.myqcloud.com/static/image/dev/running/41f1b67d2581691887816645cea3cece.jpg?imageMogr2/format/webp/quality/50', // 底部社群banner图
      // myActivityListPictures: 'https://uauat-1257321318.file.myqcloud.com/static/image/dev/running/863718b7235f9ae06d912962bd022c56.png?imageMogr2/format/webp/quality/50', // 我的活动列表图
      // shareCardImage: 'https://uauat-1257321318.file.myqcloud.com/static/image/dev/running/154438e5476d577a8b1db07fb9fdc6b2.jpg?imageMogr2/format/webp/quality/50', // 分享卡片长途
      // shareImage: 'https://uauat-1257321318.file.myqcloud.com/static/image/dev/running/401f83162271b40ef19e4d9a2fe2cec6.jpg?imageMogr2/format/webp/quality/50', // 分享长图
      // runningBackgroundImage: '', // 跑步背景图
    };
    this.communityBanner = {
      imageUrl: '', // 社群banner图
      linkUrl: '', // 社群链接地址
    };
    this.courseBanner = {
      imageUrl: '', // 课程banner图
      linkUrl: '', // 课程链接地址
    };
  }
}
